import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";

import { onboardingQKeys } from "@hooks/queries/onboarding/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


export const useVerifySession = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();
  return useMutation({
    mutationFn: ({ sessionId, checks, publishProfile }: {
      sessionId: string;
      checks: Record<string, boolean>;
      publishProfile: boolean;
    }) => api.post(`onboarding/admin/queue/${sessionId}/verify`, {
      checks,
      publish_profile: publishProfile,
    }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: onboardingQKeys.queue() }),
    onError: (res: any) => handleErrors(res, "mutation"),
  });
};

